module.exports = __webpack_public_path__ + "img/drafts.fb3b5925.svg";